import firebase from 'firebase'
import Logo from '../../public/img/ico/RiskIt_Icon.svg'
import LogoWhite from '../../public/img/ico/RiskIt_Icon_White.svg'

const config = {
  apiKey: 'AIzaSyC2VSS1eW5AsA3JUDA1founRHOewqYu1N4',
  authDomain: 'riskit-5616e.firebaseapp.com',
  databaseURL: 'https://riskit-5616e.firebaseio.com',
  storageBucket: 'riskit-5616e.appspot.com',
  messagingSenderId: '313357428634'
}

firebase.initializeApp(config)

export const ref = firebase.database().ref()
export const firebaseAuth = firebase.auth
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const facebookProvider = new firebase.auth.FacebookAuthProvider()

export const title = 'RiskIt'
export const logo = Logo
export const logoWhite = LogoWhite

export const areas = {
  1: 'Financial Impact',
  2: 'Cleints & Staff Health & Safety',
  3: 'Business Interruption',
  4: 'Reputation & Image',
  5: 'Corporate Objectives'
}
export const likelihoods = {
  1: {
    short: 'Rare',
    long: 'Highly unlikely, but it may occur in exceptional circumstances. It could happen, but probably never will.'
  },
  2: {
    short: 'Unlikely',
    long: 'Not expected, but there\'s a slight possibility it may occur at some time.'
  },
  3: {
    short: 'Possible',
    long: '	The event might occur at some time as there is a history of casual occurrence at the University &/or similar institutions.'
  },
  4: {
    short: 'Likely',
    long: 'There is a strong possibility the event will occur as there is a history of frequent occurrence at the University &/or similar institutions.'
  },
  5: {
    short: 'Almost Certain',
    long: '	Very likely. The event is expected to occur in most circumstances as there is a history of regular occurrence at the University &/or similar institutions.'
  }
}
export const consequences = {
  1: {
    short: 'Insignificant',
    areas: {
      1: 'Minimal financial loss; Less than $300,000',
      2: 'No or only minor personal injury; First Aid needed but no days lost',
      3: 'Negligible; Critical systems unavailable for less than one hour',
      4: 'Negligible impact',
      5: 'Resolved in day-to-day management'
    }
  },
  2: {
    short: 'Minor',
    areas: {
      1: '$300,000 to $2M; not covered by insurance',
      2: 'Minor injury; Medical treatment & some days lost',
      3: 'Inconvenient; Critical systems unavailable for several hours',
      4: 'Adverse local media coverage only',
      5: 'Minor impact'
    }
  },
  3: {
    short: 'Moderate',
    areas: {
      1: '$2M to $5M; not covered by insurance',
      2: 'Injury; Possible hospitalisation & numerous days lost',
      3: 'Client dissatisfaction; Critical systems unavailable for less than 1 day',
      4: 'Adverse capital city media coverage',
      5: 'Significant impact'
    }
  },
  4: {
    short: 'Major',
    areas: {
      1: '$5M to $10M; not covered by insurance',
      2: 'Single death &/or long-term illness or multiple serious injuries',
      3: 'Critical systems unavailable for 1 day or a series of prolonged outages',
      4: 'Adverse and extended national media coverage',
      5: 'Major impact'
    }
  },
  5: {
    short: 'Catastrophic',
    areas: {
      1: 'Above $10M; not covered by insurance',
      2: 'Fatality(ies) or permanent disability or ill-health',
      3: 'Critical systems unavailable for more than a day (at a crucial time)',
      4: 'Demand for government inquiry',
      5: 'Disastrous impact'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/constants.js